//@flow strict

import * as React from 'react';
import logger from 'src/utils/logger';
import {SUPPORTED_LANGUAGES} from 'src/constants/language-support';
import useLabelTranslation from 'src/hooks/useLabelTranslation';


export const isLanguageSupported = (language: string): boolean => {
  return SUPPORTED_LANGUAGES.includes(language);
};

// using HOC to inject the `t` function into the class component
// $FlowFixMe[signature-verification-failure]
export function withI18n(Component) {
  return function WrapperComponent(props) {
    const {t, makeKey} = useLabelTranslation();
    return <Component {...props} t={t} makeKey={makeKey} />;
  };
}

// browser language with comprehensive error handling
export const getBrowserLanguage = (): string | null => {
  let detectedBrowserLanguage = null;
  try {
    // check if navigator is available (important for SSR pages)
    if (typeof navigator === 'undefined') {
      return detectedBrowserLanguage;
    }
    const browserLanguage = navigator.language || '';
    detectedBrowserLanguage =
      browserLanguage === 'en-US' ? 'en' : browserLanguage;
    return isLanguageSupported(detectedBrowserLanguage)
      ? detectedBrowserLanguage
      : null;
  } catch (error) {
    logger.error('Error detecting browser language:', error);
    return detectedBrowserLanguage;
  }
};
